import { useTranslation } from 'react-i18next';
import type { SupportCaseStatus } from '../types/supportCase';

interface SupportCaseStatusBadgeProps {
  readonly status: string; // string (not SupportCaseStatus) — tolerates unknown future statuses gracefully
}

const STATUS_STYLES: Record<SupportCaseStatus, string> = {
  OPEN:        'bg-emerald-100 text-emerald-700',
  IN_PROGRESS: 'bg-blue-100 text-blue-700',
  RESOLVED:    'bg-gray-100 text-gray-700',
  ABANDONED:   'bg-red-100 text-red-700',
};

const KNOWN_STATUSES = Object.keys(STATUS_STYLES) as SupportCaseStatus[];

export const SupportCaseStatusBadge = ({ status }: SupportCaseStatusBadgeProps) => {
  const { t } = useTranslation('badges');

  const STATUS_LABELS: Record<SupportCaseStatus, string> = {
    OPEN:        t('supportCaseStatusOpen'),
    IN_PROGRESS: t('supportCaseStatusInProgress'),
    RESOLVED:    t('supportCaseStatusResolved'),
    ABANDONED:   t('supportCaseStatusAbandoned'),
  };

  const isKnown = KNOWN_STATUSES.includes(status as SupportCaseStatus);
  const classes = isKnown
    ? STATUS_STYLES[status as SupportCaseStatus]
    : 'bg-gray-100 text-gray-600';
  const label = isKnown
    ? STATUS_LABELS[status as SupportCaseStatus]
    : status;

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${classes}`}>
      {label}
    </span>
  );
};
